import { useSelector } from "react-redux";

function useIframe() {
  const iframe = useSelector(({ iframe }) => iframe);
  return { iframe };
}

export default useIframe;
